const logger = window.console.log

window.console._allMessages = []

const logMessage = (...attrs) => {
  window.console._allMessages.push(attrs)
  window.dispatchEvent(new CustomEvent('logMessage', { detail: attrs }))
  logger.apply(console, attrs)
}

const captureConsole = () => {
  window.console.log = logMessage
}

export default captureConsole
